/**
 * Returns a property decorator.
 *
 * @param { Property } propData
 * @returns { PropertyDecorator }
 */
const property = (propData) => {
    return (target, propertyKey) => {
        const ctor = target.constructor;
        if (!Object.prototype.hasOwnProperty.call(ctor, "decoratorMetadata")) {
            ctor.decoratorMetadata = {};
        }
        const decoratorMetadata = ctor.decoratorMetadata;
        if (!decoratorMetadata.properties) {
            decoratorMetadata.properties = {};
        }
        const propsMetadata = decoratorMetadata.properties;
        if (!propsMetadata[propertyKey]) {
            propsMetadata[propertyKey] = propData || { type: String };
        }
    };
};
export default property;
//# sourceMappingURL=property.js.map